// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__35uss","is-muted":"badge_is-muted__10dz2"};